export default {
  VALID: 'Valid',
  INVALID: 'Invalid',
  ERRORED: 'Errored',
};
